import { ErrorMessage } from "@hookform/error-message";
import { Box } from "@mui/material";
import { FieldErrors } from "react-hook-form";

export const FormErrorMessage = ({ errors, name }: { errors?: FieldErrors; name: string }) => {
	return (
		<ErrorMessage
			errors={errors}
			name={name}
			render={({ message }) => (
				<Box sx={{
					color: "#f44336",
					fontSize: 10,
					fontWeight: 600,
					marginTop: 0.5,
					whiteSpace: "wrap",
				}}>
					{message}
				</Box>
			)}
		/>
	);
};
